































import { defineComponent } from '@vue/composition-api';
import { t } from '@getaccept/lib-shared/src/helpers/translation.helper';
import { ParagraphSize } from '@getaccept/lib-ui';
import { storeToRefs } from 'pinia';

import { TooltipPlacement } from '@getaccept/lib-shared/src/enums/tooltip-placement';
import { useSubscriptionStore } from '../store/subscription.store';

export default defineComponent({
  props: {
    compact: { type: Boolean },
  },
  setup() {
    const { daysLeft } = storeToRefs(useSubscriptionStore());

    return {
      t,
      ParagraphSize,
      daysLeft,
      TooltipPlacement,
    };
  },
});
